import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  FileText,
  PlusCircle,
  ShoppingBag,
  Search,
  Package,
  Filter,
  X,
} from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import {
  Button,
  Col,
  Dropdown,
  Modal,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import AsyncSelect from 'react-select/async'
import { toast } from 'react-toastify'
import blingImg from '../../assets/bling.png'
import { Ask } from '../../components/Ask/index.jsx'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import { CustomSpinner } from '../../components/CustomSpinner'
import ListaProdutos from '../../components/ListaProduto/listaproduto'
import Navbar from '../../components/navbar/navbar'
import { useProducts } from '../../hooks/useProducts/index.js'
import apinode from '../../services/apinode'
import BlingService from '../../services/database/BlingService/index.js'
import CategoriesService from '../../services/database/CategoriesService/index.js'
import SubcategoriesService from '../../services/database/SubcategoriesService/index.js'
import { gerarRelatorioUltimosDias } from '../../utils/relatorios/relatorioUltimosDias.js'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import { unifyParams } from '../../utils/unifyParams.js'
import AtualizarEstoqueModal from './modalEstoque.jsx'
import { ModalExpLeroy } from './ModalExpLeroy/index.jsx'
import MovimentacaoEstoqueModal from './modalmov.jsx'
import { ArrowsCollapse, ArrowsExpand } from 'react-bootstrap-icons'

// ── Estilos inline centralizados ──────────────────────────────────────────────
const styles = {
  pageWrapper: {
    backgroundColor: '#f5f7fa',
    minHeight: '100vh',
    position: 'relative',
  },
  container: {
    width: '100%',
    padding: '28px 32px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '28px',
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  titleIcon: {
    width: '42px',
    height: '42px',
    borderRadius: '12px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
  },
  h1: {
    fontSize: '1.65rem',
    fontWeight: 700,
    color: '#1a1d23',
    margin: 0,
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '0.82rem',
    color: '#8892a4',
    margin: 0,
    fontWeight: 400,
  },
  headerActions: {
    display: 'flex',
    gap: '10px',
  },
  btnBase: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    border: 'none',
    padding: '9px 16px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: 600,
    color: '#fff',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  btnRelatorio: {
    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  },
  btnLeroy: {
    background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    color: '#064e2b',
  },
  btnAdd: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  searchSection: {
    background: '#ffffff',
    borderRadius: '16px',
    padding: '20px 24px',
    marginBottom: '20px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
    border: '1px solid #eef0f4',
  },
  searchRow: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    marginBottom: '16px',
  },
  searchInputWrapper: {
    flex: 1,
    position: 'relative',
  },
  searchInput: {
    width: '100%',
    padding: '11px 16px 11px 42px',
    borderRadius: '10px',
    border: '1.5px solid #e2e6ed',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    backgroundColor: '#fafbfc',
  },
  searchIconInside: {
    position: 'absolute',
    left: '14px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#9ca3af',
    pointerEvents: 'none',
  },
  searchBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '11px 22px',
    borderRadius: '10px',
    border: 'none',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    fontWeight: 600,
    fontSize: '0.88rem',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease, transform 0.1s ease',
    whiteSpace: 'nowrap',
  },
  filtersLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#8892a4',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '10px',
  },
  filtersRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '12px',
    alignItems: 'center',
  },
  filterSelect: {
    padding: '9px 12px',
    borderRadius: '8px',
    border: '1.5px solid #e2e6ed',
    fontSize: '0.85rem',
    color: '#4a5568',
    backgroundColor: '#fafbfc',
    outline: 'none',
    transition: 'border-color 0.2s ease',
    width: '100%',
    cursor: 'pointer',
  },
  checkboxWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '9px 12px',
    borderRadius: '8px',
    border: '1.5px solid #e2e6ed',
    backgroundColor: '#fafbfc',
    cursor: 'pointer',
    fontSize: '0.85rem',
    color: '#4a5568',
    transition: 'border-color 0.2s ease',
  },
  tableCard: {
    background: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
    border: '1px solid #eef0f4',
    overflow: 'hidden',
  },
  tableCardBody: {
    padding: '16px 20px',
    height: 'calc(100vh - 340px)',
    minHeight: '400px',
    overflowY: 'auto',
  },
  spinnerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '400px',
    gap: '16px',
  },
  spinnerText: {
    fontSize: '0.9rem',
    color: '#8892a4',
    fontWeight: 500,
  },
  errorBar: {
    margin: '16px 0',
    padding: '12px 20px',
    borderRadius: '10px',
    backgroundColor: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#dc2626',
    fontSize: '0.88rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  // Modal Composição
  composicaoTable: {
    fontSize: '0.88rem',
  },
  custoMedioBadge: {
    display: 'inline-block',
    padding: '6px 14px',
    backgroundColor: '#eef2ff',
    color: '#4f46e5',
    borderRadius: '8px',
    fontWeight: 600,
    fontSize: '0.9rem',
  },
  composicaoNote: {
    color: '#64748b',
    fontSize: '0.82rem',
    padding: '12px 16px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
    borderLeft: '3px solid #667eea',
    marginTop: '16px',
  },
  // Modal Exportar
  exportProductName: {
    fontWeight: 600,
    fontSize: '1rem',
    color: '#1a1d23',
    padding: '8px 14px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
    borderLeft: '3px solid #667eea',
    marginBottom: '16px',
  },
  exportLabel: {
    fontSize: '0.82rem',
    fontWeight: 600,
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: '6px',
  },
  exportPreview: {
    marginTop: '20px',
    padding: '16px',
    backgroundColor: '#f8fafc',
    borderRadius: '12px',
    border: '1px solid #eef0f4',
  },
  exportPreviewImg: {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '8px',
    marginBottom: '12px',
  },
  exportPreviewTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#1a1d23',
    marginBottom: '8px',
  },
  exportPreviewLink: {
    textDecoration: 'none',
    color: '#667eea',
    fontSize: '0.9rem',
    fontWeight: 600,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  },
  // Modal Relatório
  reportModalInput: {
    padding: '11px 14px',
    borderRadius: '10px',
    border: '1.5px solid #e2e6ed',
    fontSize: '0.9rem',
    outline: 'none',
    width: '100%',
    transition: 'border-color 0.2s ease',
  },
}

export function Produtos() {
  const [busca, setBusca] = useState('')
  const [texto, setTexto] = useState('')
  const [products, setProducts] = useState([])
  const [buscarProdutosComposicao, setBuscarProdutosComposicao] =
    useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [selectedOption, setSelectedOption] = useState('APELIDO')
  const [selectedMarktPlaces, setSelectedMarktplaces] = useState([])
  const [showExportModal, setShowExportModal] = useState(false)
  const [isProductsLoading, setIsProductsLoading] = useState(false)
  const [isLoadingProduct, setIsLoadingProduct] = useState(true)
  const [showUpdateStockModal, setShowUpdateStockModal] = useState(false)
  const [selectedSku, setSelectedSku] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [historicoMov, setHistoricoMov] = useState([])
  const [nomeProduto, setNomeProduto] = useState('')

  const [ValueSelecionado, setSelecionadoValor] = useState('')
  const [retornodedados, setRetornoDados] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [marktPlace, setMartkPlace] = useState('')
  const [composicao, setComposicao] = useState([])
  const [showComposicao, setShowComposicao] = useState(false)
  const [marcas, setMarcas] = useState([])
  const [selectedMarca, setSelectedMarca] = useState('')
  const [categorias, setCategorias] = useState([])
  const [subcategorias, setSubcategorias] = useState([])
  const [selectCategoria, setSelectCategoria] = useState('')
  const [selectSubcategoria, setSelectSubcategoria] = useState('')
  const [daysOfSales, setDaysOfSales] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isRequestBlingLoading, setIsRequestBlingLoading] = useState(false)
  const [selectEstoque, setSelectEstoque] = useState('')
  const [isSectionVisible, setIsSectionVisible] = useState(true)

  const productSelected = useProducts()

  const handleMarcaChange = (event) => {
    setSelectedMarca(event.target.value)
  }

  const handleComposicao = async (item) => {
    try {
      const response = await apinode.get(
        `/custos/listacomposicao/${item}/${localStorage.idconta}`,
      )
      setComposicao(response.data)
      setShowComposicao(true)
    } catch (error) {
      console.error('Erro ao buscar composições:', error)
      return []
    }
  }

  async function loadCategorias() {
    try {
      const data = await CategoriesService.getAll()
      setCategorias(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as categorias!')
    }
  }

  async function loadSubcategorias() {
    try {
      const data = await SubcategoriesService.getAll()
      setSubcategorias(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as subcategorias!')
    }
  }

  const ProductModal = ({ show, handleClose, composicao }) => {
    const calcularCustoMedio = (composicao) => {
      let total = 0
      let quantidadeTotal = 0

      composicao.forEach((item) => {
        if (item.qtestger > 0 && item.precocusto > 0) {
          total += item.qtestger * item.precocusto
          quantidadeTotal += item.qtestger
        }
      })
      if (quantidadeTotal === 0) return 0

      return (total / quantidadeTotal).toFixed(2)
    }

    let custoMedio = 0

    if (composicao.some((item) => item.qtestger > 0)) {
      custoMedio = calcularCustoMedio(composicao)
    }

    if (composicao.length > 0) {
      custoMedio = calcularCustoMedio(composicao)
    }

    return (
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="custom-modalzpl"
        centered
      >
        <Modal.Header
          closeButton
          style={{ borderBottom: '1px solid #eef0f4', padding: '16px 24px' }}
        >
          <Modal.Title
            style={{ fontSize: '1.1rem', fontWeight: 700, color: '#1a1d23' }}
          >
            <span style={{ marginRight: '8px' }}>📦</span>
            Produtos filhos com custo médio
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '20px 24px' }}>
          <Table
            striped
            bordered
            hover
            style={styles.composicaoTable}
          >
            <thead style={{ backgroundColor: '#f8fafc' }}>
              <tr>
                <th>SKU</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Preço de Custo</th>
                <th>Preço Venda</th>
                <th style={{ textAlign: 'center' }}>Ação</th>
              </tr>
            </thead>
            <tbody>
              {composicao.length === 0 ? (
                <tr>
                  <td
                    colSpan="6"
                    style={{
                      textAlign: 'center',
                      padding: '32px',
                      color: '#8892a4',
                    }}
                  >
                    Produto sem filhos
                  </td>
                </tr>
              ) : (
                composicao.map((item) => (
                  <tr key={item.sku}>
                    <td style={{ fontWeight: 600, color: '#4f46e5' }}>
                      {item.sku}
                    </td>
                    <td>{item.descricao}</td>
                    <td style={{ textAlign: 'center' }}>{item.qtestger}</td>
                    <td>
                      {localStorage.admin === 'SIM' &&
                        item.precocusto.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                    </td>
                    <td>
                      {item.precovenda.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <Link
                        to={`/produtos/${item.codproduto}`}
                        className="btn btn-sm"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          backgroundColor: '#eef2ff',
                          color: '#4f46e5',
                          borderRadius: '6px',
                          padding: '4px 10px',
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faEdit}
                          title="Editar"
                        />
                      </Link>
                    </td>
                  </tr>
                ))
              )}
              {custoMedio > 0 && localStorage.admin === 'SIM' && (
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: 600 }}
                  >
                    <span style={styles.custoMedioBadge}>Custo Médio</span>
                  </td>
                  <td style={{ fontWeight: 700, color: '#4f46e5' }}>
                    {custoMedio}
                  </td>
                  <td colSpan="2"></td>
                </tr>
              )}
            </tbody>
          </Table>

          <p style={styles.composicaoNote}>
            Custo médio é calculado somando o custo de cada item ao estoque
            positivo.
          </p>
        </Modal.Body>
      </Modal>
    )
  }

  // Modals Leroy
  const [isModalExpLeroyOpen, setIsModalExpLeroyOpen] = useState(false)

  const handleInputChange = (e) => {
    setInputValue(e.target.value)
  }

  const handleInputBlur = () => {
    const roundedValue = parseFloat(inputValue).toFixed(2)
    setInputValue(roundedValue)
  }

  async function handleClonar(item) {
    return await Ask(
      'Tem certeza de que deseja clonar este produto?',
      async () => {
        try {
          setIsProductsLoading(true)

          const response = await apinode.get(
            `/estoque/clonar/${item}/${localStorage.idconta}`,
          )

          toast.success(
            `Produto clonado com sucesso com SKU ${response.data.sku}`,
          )

          await fetchProductsAll()
        } catch (error) {
          setError(error)
          toast.error('Falha ao clonar')
        } finally {
          setIsProductsLoading(false)
        }
      },
    )
  }

  const handleExportarProdutosMercadoLivre = async () => {
    if (marktPlace === 'Magalu') {
      try {
        const response = await apinode.post(
          `/magalu/product/${selectedOption}/${selectedSku}/${localStorage.idconta}`,
          {
            category_id: ValueSelecionado,
            precovenda: inputValue,
          },
        )
        toast.success('Produto exportado com sucesso!')
        setRetornoDados(response.data.produto)
      } catch (error) {
        setError(error)
        toast.error('Falha ao exportar')
      }
    } else {
      try {
        const response = await apinode.post(
          `/exportml/itemmercadolivre/${selectedOption}/${selectedSku}/${localStorage.idconta}`,
          {
            category_id: ValueSelecionado,
            precovenda: inputValue,
          },
        )
        toast.success('Produto exportado com sucesso!')
        setRetornoDados(response.data.produto)
      } catch (error) {
        setError(error)
        toast.error('Falha ao exportar')
      }
    }
  }

  const handleSelectChange = (selectedValues) => {
    setSelecionadoValor(selectedValues?.value)
  }

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  const produto = {
    nome: nomeProduto,
  }

  const fetchHistoryMov = async (item) => {
    try {
      setIsProductsLoading(true)
      const response = await apinode.get(
        `/estoque/mov/${item}/${localStorage.idconta}`,
      )
      setHistoricoMov(response.data)
      handleOpenModal()
    } catch (error) {
      setError(error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  const loadOptions = async (inputValue, callback) => {
    try {
      const response = await apinode.get(
        `/exportml/domaindiscovery/${inputValue}/${selectedOption}/${localStorage.idconta}`,
      )
      const data = response.data

      const options = data.map((item) => ({
        value: item.category_id,
        label: item.domain_name,
      }))

      callback(options)
    } catch (error) {
      console.error('Erro ao buscar opções da API:', error)
      callback([])
    }
  }

  const handleMovProd = async (item, nomeprod) => {
    fetchHistoryMov(item)
    setNomeProduto(nomeprod)
  }

  const buttonSearchRef = useRef(null)
  const navigate = useNavigate()

  const clickExport = async (Item, ValorProd, NomeProd) => {
    setShowExportModal(true)
    setSelectedSku(Item)
    setInputValue(ValorProd)
    setNomeProduto(NomeProd)
  }

  async function handleImportProduct() {
    try {
      setIsRequestBlingLoading(true)

      const responseMessage = await BlingService.importProduct(selectedSku)

      toast.success(responseMessage)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível concluir a exportação!')
    } finally {
      setIsRequestBlingLoading(false)
    }
  }

  const clickAjustStock = async (item) => {
    setSelectedSku(item)
    setShowUpdateStockModal(true)
  }

  const handleCloseExportModal = () => {
    setShowExportModal(false)
  }

  const handleButtonClick = () => {
    setBusca(texto)
    fetchProducts(localStorage.idconta, texto)
  }

  async function fetchProductsAll() {
    setIsLoadingProduct(true)

    try {
      const response = await apinode.get(
        `/estoque/${localStorage.idconta}?idusuario=${localStorage.idusuario}`,
      )

      setProducts(response.data)
    } catch (error) {
      sendErrorApiMessage(error, 'Erro ao buscar produtos!')
    } finally {
      setIsLoadingProduct(false)
    }
  }

  async function fetchRelatorio90dias() {
    setIsProductsLoading(true)
    try {
      const skus =
        productSelected.productsToExport.length > 0
          ? productSelected.productsToExport.map((product) => product.SKU)
          : products.map((product) => product.SKU)

      const response = await apinode.post(
        `/relatorios/90dias/${localStorage.idconta}`,
        { skus, daysOfSales },
      )

      setIsModalOpen(false)
      gerarRelatorioUltimosDias(daysOfSales, response.data)
    } catch (error) {
      setError(error)
      toast.error('Erro ao buscar produtos, Resposta:', error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  async function fetchMarcas() {
    setIsProductsLoading(true)

    try {
      const response = await apinode.get(
        `/estoque/marca/${localStorage.idconta}`,
      )

      setMarcas(response.data)
    } catch (error) {
      setError(error)
      toast.error('Erro ao buscar marcas, Resposta:', error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  async function fetchProducts(conta, sku) {
    try {
      setIsProductsLoading(true)

      const url = unifyParams(`/estoque/lista-produto`, [
        {
          key: 'conta',
          value: conta,
        },
        {
          key: 'sku',
          value: sku,
        },
        {
          key: 'idusuario',
          value: localStorage.idusuario,
        },
        {
          key: 'categoria',
          value: selectCategoria,
        },
        {
          key: 'subcategoria',
          value: selectSubcategoria,
        },
        {
          key: 'marca',
          value: selectedMarca,
        },
        {
          key: 'composicao',
          value: buscarProdutosComposicao ? 'S' : 'N',
        },
        {
          key: 'estoque',
          value: selectEstoque,
        },
      ])

      const response = await apinode.get(url)
      setProducts(response.data)
      setError(null)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar produtos')
      setError(err)
      setProducts([])
    } finally {
      setIsProductsLoading(false)
    }
  }

  async function fetchContas(conta) {
    try {
      const url = `lojasvirtuais/${conta}`

      const response = await apinode.get(url)
      setSelectedMarktplaces(response.data)
      setIsLoading(false)
    } catch (error) {
      setError(error)
      setIsLoading(false)
    }
  }

  async function confirmDeleteUser(id) {
    setIsProductsLoading(true)

    try {
      await apinode.delete(`/estoque/${localStorage.idconta}/${id}`)
      fetchProductsAll()
      toast.success('Produto deletado com sucesso!')
    } catch (error) {
      setError(error)
      toast.error('Erro ao deletar produto, Resposta:', error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  const handleSelect = (selectedKey, event) => {
    const selectedID_CONTA = selectedMarktPlaces.find(
      (item) => item.APELIDO === selectedKey,
    ).ID_CONTA

    const selectedMarkPlace = selectedMarktPlaces.find(
      (item) => item.APELIDO === selectedKey,
    ).ID_CONTA
    setSelectedOption(selectedID_CONTA)

    const plataforma = selectedMarktPlaces.find(
      (item) => item.APELIDO === selectedKey,
    ).PLATAFORMA

    setMartkPlace(plataforma)
  }

  function handleModalSubmit() {
    fetchRelatorio90dias()
  }

  function handleOpenModalLeroy() {
    setIsModalExpLeroyOpen(true)
  }

  useEffect(function () {
    fetchContas(localStorage.idconta)
    fetchProductsAll()
    fetchMarcas()
    loadCategorias()
    loadSubcategorias()
  }, [])

  return (
    <div style={styles.pageWrapper}>
      <Navbar />

      <div style={styles.container}>
        {/* ── Header ──────────────────────────────────────────────── */}
        <div style={styles.header}>
          <div style={styles.headerTitle}>
            <div style={styles.titleIcon}>
              <Package size={22} />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <h1 style={styles.h1}>Produtos</h1>
              <p style={styles.subtitle}>Gerencie seu catálogo de produtos</p>
            </div>
          </div>

          <div style={styles.headerActions}>
            <button
              onClick={() => setIsModalOpen(true)}
              style={{ ...styles.btnBase, ...styles.btnRelatorio }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.9')}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
            >
              <FileText size={17} />
              <span>Relatório</span>
            </button>

            <button
              title="Exportar Produtos LM"
              onClick={handleOpenModalLeroy}
              style={{ ...styles.btnBase, ...styles.btnLeroy }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.9')}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
            >
              <ShoppingBag size={17} />
              <span>Exportar LM</span>
            </button>

            <button
              title="Adicionar"
              onClick={() => navigate('/produtos/novo')}
              style={{ ...styles.btnBase, ...styles.btnAdd }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.9')}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
            >
              <PlusCircle size={18} />
              <span>Adicionar</span>
            </button>
          </div>
        </div>

        {/* ── Busca & Filtros ─────────────────────────────────────── */}
        <div style={styles.searchSection}>
          <div style={styles.searchRow}>
            <div style={styles.searchInputWrapper}>
              <Search
                size={16}
                style={styles.searchIconInside}
              />
              <input
                type="text"
                value={texto}
                onChange={(e) => setTexto(e.target.value)}
                style={styles.searchInput}
                placeholder="Pesquisar por SKU ou descrição..."
                onKeyUp={(e) =>
                  e.key === 'Enter' && buttonSearchRef.current?.click(e)
                }
                onFocus={(e) => {
                  e.target.style.borderColor = '#667eea'
                  e.target.style.boxShadow = '0 0 0 3px rgba(102,126,234,0.12)'
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e2e6ed'
                  e.target.style.boxShadow = 'none'
                }}
              />
            </div>
            <button
              ref={buttonSearchRef}
              onClick={handleButtonClick}
              style={{
                ...styles.searchBtn,
                opacity: isProductsLoading ? 0.7 : 1,
                cursor: isProductsLoading ? 'not-allowed' : 'pointer',
              }}
              disabled={isProductsLoading}
            >
              <Search size={16} />
              <span>{isProductsLoading ? 'Pesquisando...' : 'Pesquisar'}</span>
            </button>

            <CustomButton
              onClick={() => setIsSectionVisible((prevState) => !prevState)}
            >
              {isSectionVisible ? (
                <ArrowsCollapse size={25} />
              ) : (
                <ArrowsExpand size={25} />
              )}
            </CustomButton>
          </div>

          {isSectionVisible && (
            <>
              <div style={styles.filtersLabel}>
                <Filter size={13} />
                Filtros
              </div>

              <div style={styles.filtersRow}>
                <select
                  style={styles.filterSelect}
                  value={selectedMarca}
                  onChange={handleMarcaChange}
                >
                  <option value="">Todas as marcas</option>
                  {marcas.map((marca) => (
                    <option
                      key={marca.ID_MARCA}
                      value={marca.ID_MARCA}
                    >
                      {marca.DESC_MARCA}
                    </option>
                  ))}
                </select>

                <select
                  style={styles.filterSelect}
                  value={selectCategoria}
                  onChange={(e) => setSelectCategoria(e.target.value)}
                >
                  <option value="">Todas as categorias</option>
                  {categorias.map((categoria) => (
                    <option
                      key={categoria.id_categoria}
                      value={categoria.id_categoria}
                    >
                      {categoria.categoria}
                    </option>
                  ))}
                </select>

                <select
                  style={styles.filterSelect}
                  value={selectSubcategoria}
                  onChange={(e) => setSelectSubcategoria(e.target.value)}
                >
                  <option value="">Todas as subcategorias</option>
                  {subcategorias.map((subcategoria) => (
                    <option
                      key={subcategoria.id_subcategoria}
                      value={subcategoria.id_subcategoria}
                    >
                      {subcategoria.subcategoria}
                    </option>
                  ))}
                </select>

                <label
                  style={styles.checkboxWrapper}
                  onClick={() =>
                    setBuscarProdutosComposicao((prevState) => !prevState)
                  }
                >
                  <input
                    type="checkbox"
                    checked={buscarProdutosComposicao}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setBuscarProdutosComposicao(true)
                      } else {
                        setBuscarProdutosComposicao(false)
                      }
                    }}
                    style={{ accentColor: '#667eea', cursor: 'pointer' }}
                  />
                  Com composição
                </label>

                <select
                  style={styles.filterSelect}
                  value={selectEstoque}
                  onChange={(e) => setSelectEstoque(e.target.value)}
                >
                  <option value="">Todos produtos com ou sem estoque</option>
                  <option value="com">Apenas produtos com estoque</option>
                  <option value="sem">Apenas produtos sem estoque</option>
                </select>
              </div>
            </>
          )}
        </div>

        {/* ── Erro ────────────────────────────────────────────────── */}
        {error && (
          <div style={styles.errorBar}>
            <X size={16} />
            Erro: {error.message}
          </div>
        )}

        {/* ── Tabela de Produtos ──────────────────────────────────── */}
        <div style={styles.tableCard}>
          <div style={styles.tableCardBody}>
            {!error && isProductsLoading ? (
              <div style={styles.spinnerWrapper}>
                <CustomSpinner />
                <span style={styles.spinnerText}>Carregando produtos...</span>
              </div>
            ) : (
              <ListaProdutos
                busca={busca}
                isLoadingProduct={isLoadingProduct}
                texto={texto}
                arrayClientes={products}
                clickDelete={confirmDeleteUser}
                clickExport={clickExport}
                clickAjustStock={clickAjustStock}
                clickMovProd={handleMovProd}
                clickClonar={handleClonar}
                clickComposicao={handleComposicao}
                isSectionVisible={isSectionVisible}
              />
            )}
          </div>
        </div>

        {/* ── Modais ──────────────────────────────────────────────── */}
        <AtualizarEstoqueModal
          show={showUpdateStockModal}
          handleClose={() => setShowUpdateStockModal(false)}
          SkuAtualizar={selectedSku}
        />

        {/* Modal de exportação */}
        <Modal
          show={showExportModal}
          onHide={handleCloseExportModal}
          centered
        >
          <Modal.Header
            closeButton
            style={{ borderBottom: '1px solid #eef0f4', padding: '16px 24px' }}
          >
            <Modal.Title
              style={{
                fontSize: '1.1rem',
                fontWeight: 700,
                color: '#1a1d23',
              }}
            >
              Exportar Produto
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px 24px' }}>
            <div style={styles.exportProductName}>{nomeProduto}</div>

            <Row className="mb-3">
              <Col>
                <p style={styles.exportLabel}>Buscar opção na API</p>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={loadOptions}
                  onChange={handleSelectChange}
                />
              </Col>
            </Row>

            <Row className="g-3">
              <Col>
                <p style={styles.exportLabel}>Valor do anúncio</p>
                <input
                  type="text"
                  placeholder="Digite um valor"
                  value={inputValue}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                  className="form-control"
                  style={{ borderRadius: '8px' }}
                />
              </Col>

              <Col>
                <p style={styles.exportLabel}>Conta destino</p>
                <Dropdown onSelect={handleSelect}>
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                    style={{ borderRadius: '8px', width: '100%' }}
                  >
                    {selectedOption}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {selectedMarktPlaces.map((item) => (
                      <Dropdown.Item
                        key={item.ID_CONTA}
                        eventKey={item.APELIDO}
                      >
                        {item.APELIDO}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>

            {retornodedados && (
              <div style={styles.exportPreview}>
                {retornodedados.thumbnail && (
                  <img
                    src={retornodedados.thumbnail}
                    alt={retornodedados.title}
                    style={styles.exportPreviewImg}
                  />
                )}
                {retornodedados.title && (
                  <h3 style={styles.exportPreviewTitle}>
                    {retornodedados.title}
                  </h3>
                )}
                {retornodedados.permalink && (
                  <a
                    href={retornodedados.permalink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.exportPreviewLink}
                  >
                    Ir para o Produto →
                  </a>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer
            style={{
              borderTop: '1px solid #eef0f4',
              padding: '14px 24px',
              gap: '8px',
            }}
          >
            <CustomButton
              onClick={handleCloseExportModal}
              isDelete
            >
              Fechar
            </CustomButton>

            <OverlayTrigger overlay={<Tooltip>Exportar para o Bling</Tooltip>}>
              <CustomButton
                color="#001b0e"
                onClick={handleImportProduct}
                isLoading={isRequestBlingLoading}
              >
                <img
                  src={blingImg}
                  alt="Bling Logo"
                  style={{ width: 55 }}
                />
              </CustomButton>
            </OverlayTrigger>

            <Button
              variant="primary"
              onClick={handleExportarProdutosMercadoLivre}
              style={{ borderRadius: '8px', fontWeight: 600 }}
            >
              Exportar
            </Button>
          </Modal.Footer>
        </Modal>

        <MovimentacaoEstoqueModal
          produto={produto}
          showModal={showModal}
          handleClose={handleCloseModal}
          historico={historicoMov}
        />

        <ModalExpLeroy
          isOpen={isModalExpLeroyOpen}
          onClose={() => setIsModalExpLeroyOpen(false)}
        />

        {/* Modal Relatório */}
        <Modal
          show={isModalOpen}
          onHide={() => setIsModalOpen(false)}
          centered
        >
          <Modal.Header
            closeButton
            style={{ borderBottom: '1px solid #eef0f4', padding: '16px 24px' }}
          >
            <Modal.Title
              style={{
                fontSize: '1.1rem',
                fontWeight: 700,
                color: '#1a1d23',
              }}
            >
              <span style={{ marginRight: '8px' }}>📊</span>
              Gerar Relatório
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '24px' }}>
            <p style={styles.exportLabel}>Dias de Venda</p>
            <input
              type="text"
              value={daysOfSales}
              onChange={(e) => setDaysOfSales(e.target.value)}
              placeholder="Ex: 90"
              style={styles.reportModalInput}
              onFocus={(e) => (e.target.style.borderColor = '#667eea')}
              onBlur={(e) => (e.target.style.borderColor = '#e2e6ed')}
            />
          </Modal.Body>
          <Modal.Footer
            style={{
              borderTop: '1px solid #eef0f4',
              padding: '14px 24px',
              gap: '8px',
            }}
          >
            <Button
              variant="outline-secondary"
              onClick={() => setIsModalOpen(false)}
              style={{ borderRadius: '8px' }}
            >
              Fechar
            </Button>

            <Button
              variant="primary"
              onClick={() => handleModalSubmit()}
              disabled={isProductsLoading}
              style={{
                borderRadius: '8px',
                fontWeight: 600,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                border: 'none',
              }}
            >
              {isProductsLoading ? 'Carregando...' : 'Gerar Relatório'}
            </Button>
          </Modal.Footer>
        </Modal>

        <ProductModal
          show={showComposicao}
          handleClose={() => setShowComposicao(false)}
          composicao={composicao}
        />
      </div>
    </div>
  )
}
